// extracted by mini-css-extract-plugin
export default {"notificationsZIndex":"14000","container":"_3_Q2DHYjie","backgroundContainer":"_1TGiRDVkqN"};